import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  MasterDetailForm,
  FormInput,
  FormSubmitButton,
  Widget,
  FormatText,
  Row,
  SimpleView,
  GridView,
  CompositeView,
} from '@digital/ui';
import { updatePrimeiroAcesso, getUsuarioPermissions } from '@app/api/usuario';
import { useActions } from '@digital/ui/lib/store';
import { getCodigoUsuario } from '@app/helpers';
import CreatCartaNomeacao from '../Usuario/CreatCartaNomeacao';
import { getLoggedId } from '@app/helpers';

const PrimeiroAcesso = () => {
  const loadPermissions = useActions(state => state.permission.loadPermissions);
  const [usuarioLogadoId] = useState<string>(getLoggedId());
  const [atualizarGridAnexo, setAtualizarGridAnexo] = useState(false);
  useEffect(() => {
    const nome = document.getElementById('nome');
    const imputEmail = document.getElementById('email');
    const imputSenha = document.getElementById('newPassword');
    const imputConfirmNewPassword = document.getElementById('confirmNewPassword');


    if (nome) {
      nome.setAttribute('autocomplete', 'off');
      nome.setAttribute('value', '');
    }

    if (imputEmail) {
      imputEmail.setAttribute('autocomplete', 'off');
      imputEmail.setAttribute('value', '');
    }

    if (imputSenha) {
      imputSenha.setAttribute('autocomplete', 'off');
      imputSenha.setAttribute('value', '');
    }

    if (imputConfirmNewPassword) {
      imputConfirmNewPassword.setAttribute('autocomplete', 'off');
      imputConfirmNewPassword.setAttribute('value', '');
    }
  });

  const handleSubmit = (values: any) =>
    updatePrimeiroAcesso(values).then(async resp => {
      if (resp && resp.valid) {
        setAtualizarGridAnexo(!atualizarGridAnexo);
        const permissions = await getUsuarioPermissions(resp.usuarioId);
        loadPermissions(permissions != undefined ? permissions : []);
        window.location.href = '/';
      }
    });

  return (
    <CompositeView>
      <SimpleView>
        <GridView noform>
          <MasterDetailForm
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({
              email:
                getCodigoUsuario() === '2'
                  ? Yup.string()
                    .required('o e-mail deve ser informado.')
                    .email('Deve ser informado um endereço de e-mail válido')
                    .max(50, 'O e-mail deve ter no máximo 50 caracteres.')
                  : Yup.string(),
              newPassword: Yup.string()
                .required('A nova senha deve ser informada.')
                .max(50, 'A nova senha deve ter no máximo 50 caracteres.'),
              confirmNewPassword: Yup.string()
                .required('A confirmação de senha deve ser informada.')
                .max(50, 'A confirmação de senha deve ter no máximo 50 caracteres.')
                .oneOf([Yup.ref('newPassword'), null], 'A confirmação de senha e a nova senha devem ser iguais.'),
              nome:
                getCodigoUsuario() === '2'
                  ? Yup.string()
                    .required('o nome deve ser informado.')
                    .max(50, 'O nome deve ter no máximo 50 caracteres.')
                  : Yup.string(),
            })}>
            <Widget
              title="Dados de Primeiro Acesso"
              actions={[
                <FormSubmitButton>
                  <FormatText id="ui.commons.save" uppercase />
                </FormSubmitButton>,
              ]}>
              {getCodigoUsuario() == '2' ? (
                <>
                  <Row>
                    <FormInput label="Nome" name="nome" id="nome" span={4} required />
                  </Row>
                  <Row>
                    <FormInput label="E-mail" name="email" id="email" span={4} required />
                  </Row>
                </>
              ) : (
                  <></>
                )}
              <Row>
                <FormInput label="Nova Senha" name="newPassword" id="newPassword" type="password" span={4} required />
              </Row>
              <Row>
                <FormInput
                  label="Confirmação"
                  name="confirmNewPassword"
                  id="confirmNewPassword"
                  type="password"
                  span={4}
                  required
                />
              </Row>

              {usuarioLogadoId ? (<><CreatCartaNomeacao usuarioId={usuarioLogadoId} atualizarInformacoes={atualizarGridAnexo} /> </>) : (<> </>)}
            </Widget>
          </MasterDetailForm>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default PrimeiroAcesso;
